import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import TestmonialCard from './TestmonialCard';

const testimonials = [
  {
    description:
      'You made this possible. The CTF was an unqualified success, competitors were satisfied and enjoyed the experience they had with your platform. The platform is reliable and most importantly, customer support is not only fast but also very accurate when it comes to solving any kind of problem. We at CyberSecur appreciate it and really hope you keep up the good work.',
    author: {
      name: 'Diane Samba',
      role: 'Cyber Security Analyst at Cybersecur',
      image: '/images/authors/1.png',
    },
    companyLogo: '/images/authors/1-company.png',
  },
  {
    description:
      'We hosted a one-day competition between PSU students on the 2nd of April 2020. The competition aimed to enable PSU students to learn new skills, give them hands-on experience and help them practice different cybersecurity topics.  Moreover, the competition enabled our students to get familiar with the national CTF competition platform.',
    author: {
      name: 'Dr. Iman AlMomani',
      role: 'Professor at Prince Sultan University, KSA',
      image: '/images/authors/2.png',
    },
    companyLogo: '/images/authors/2-company.png',
  },
  {
    description:
      'We ran a very nice 2-day women-only CTF in Amsterdam and have also been involved with our other events in Dubai and Singapore.',
    author: {
      name: 'Dhillon Andrew Kannabhiran',
      role: 'Founder, CEO at Hack In The Box',
      image: '/images/authors/3.png',
    },
    companyLogo: '/images/authors/3-company.png',
  },
  {
    description:
      'Organizing the ZINC CTF competition was a thrilling experience. The event brought together 65+ teams to tackle over 15 stimulating cybersecurity challenges. We appreciate the team for their responsiveness and availability whenever we need them. Their platform has been problem-free, providing us with a complete solution for CTF competitions and access to a pool of cybersecurity talents.',
    author: {
      name: 'Tamer Al-Jarajreh',
      role: 'Corporate Entrepreneurship at Zain',
      image: '/images/authors/4.png',
    },
    companyLogo: '/images/authors/4-company.png',
  },
  {
    description:
      'It was great working with you during ThreatCon CTF. The experience was amazing. Our attendees enjoyed the challenges and its diversity very much. I would recommend this for anyone who would like to host a CTF.',
    author: {
      name: 'Prakash Sharma',
      role: 'Co. Founder at Threatcon',
      image: '/images/authors/5.png',
    },
    companyLogo: '/images/authors/5-company.png',
  },
  {
    description:
      'Simulations Labs has made it very easy to host a CTF. We only focus on creating and uploading the challenges, and everything else gets taken care of. On the CTF day, we didn’t need to worry about the site going down or getting attacked.',
    author: {
      name: 'Henock Negash',
      role: 'Community Lead at Yekolo Temari',
      image: '/images/authors/6.png',
    },
    companyLogo: '/images/authors/6-company.png',
  },
];
export default function TestmonialSection() {
  return (
    <div className="flex flex-col gap-10 space-y-2 px-20">
      <div className="flex flex-col gap-4 text-center">
        <span className="text-lightBlue text-[15px] font-bold uppercase">Testimonials</span>
        <h1 className="text-[50px] font-medium">Hear from Our Satisfied Clients</h1>
      </div>
      <Carousel>
        <CarouselContent>
          {testimonials.map((testimonial, index) => (
            <CarouselItem key={index}>
              <TestmonialCard {...testimonial} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
      </Carousel>
    </div>
  );
}
